<div class="panel">

  <!-- Header area -->
  <div class="panel-header">
    <div class="panel-icon">🌿</div>
    <div class="panel-title">
      <span class="panel-title-main">Analisi GIS</span>
      <span class="panel-title-sub">Veneto · Sentinel-2</span>
      <span class="panel-title-dates">Dic 2018 – Ott 2019</span>
    </div>
  </div>

  <!-- Cluster selector -->
  <div class="section">
    <label class="section-label">Tipo di area</label>
    <div ngbDropdown container="body" class="dropdown-wrap">
      <button ngbDropdownToggle class="select-btn" type="button" id="dropdownMenuButton">
        <span class="select-btn-text">{{ buttonMessage() | cut:22 }}</span>
        <i class="fas fa-chevron-down select-chevron"></i>
      </button>
      <div ngbDropdownMenu class="dropdown-list">
        <div *ngFor="let message of mexList; let i = index">
          <a ngbDropdownItem (click)="changeCluster(i-1)" class="dropdown-opt">{{ message }}</a>
        </div>
      </div>
    </div>
  </div>

  <!-- Chart -->
  <div class="section">
    <div *ngIf="cropName" class="crop-badge">
      <i class="fas fa-map-marker-alt"></i>
      <span>{{ cropName }}</span>
    </div>
    <div class="chart-wrap">
      <apx-chart id="chart" #chart
        [fill]="chartOptions.fill!"
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [title]="chartOptions.title!"
        [xaxis]="chartOptions.xaxis!"
        [yaxis]="chartOptions.yaxis!"
        [tooltip]="chartOptions.tooltip!"
        [markers]="chartOptions.markers!"
        [plotOptions]="chartOptions.plotOptions!"
        [states]="chartOptions.states!"
        [autoUpdateSeries]="true">
      </apx-chart>
    </div>
  </div>

  <!-- Thumbnail -->
  <div class="section" *ngIf="getHoverFirstImage()">
    <label class="section-label">Immagine Sentinel-2</label>
    <div class="thumb-wrap">
      <img *ngIf="!isImageNotFound && urlImmagine" [src]="urlImmagine" class="thumb-img" width="100%"
           (error)="onImgError($event)" (load)="onImgLoad($event)">
      <div class="cloud-badge" *ngIf="isImageCloudy && !isImageNotFound && urlImmagine">
        <i class="fas fa-cloud"></i> Nuvolosità elevata
      </div>
      <div class="img-not-found" *ngIf="isImageNotFound || !urlImmagine">
        <i class="fas fa-image-slash" style="font-size:22px; opacity:0.4"></i>
        <span>Immagine non disponibile</span>
      </div>
    </div>
  </div>

</div>
